import React, { useEffect, useState } from 'react';
import { Checkbox, Grid } from '@material-ui/core';
import DefaultTable from 'app/internalPages/Lines/components/DefaultTable';
import helpers from 'app/utils/helpers';

const defaultColumnOrder = {
    autorizadoComponent: 0,
    cnpj: 1,
    deRazaoSocial: 2,
    cdEmpresa: 3,
}

/**
 * Component ConcessionariasTable.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {Array} props.data - Dados de concessionárias exibidos na tabela.
 * @param {Function} props.setData - Função para atualizar os dados da tabela.
 * @param {boolean} props.loading - Indica se os dados estão sendo carregados.
 * @param {boolean} [props.isInternalForm=false] - Define se o formulário é interno. Valor padrão é `false`.
 * @param {boolean} props.disabled - Indica se o componente está desabilitado.
 * @param {Function} props.setChanged - Função para indicar que houve mudanças nos dados.
 * @param {Object} props.columnsOrder - Possibilita informar as ordens das colunas, caso não seja informado, será utilizado a ordenação default.
 *
 * @returns {JSX.Element} O componente ConcessionariasTable.
 */
const ConcessionariasTable = ({
                                  data, setData, loading, isInternalForm = false,
                                  disabled, setChanged, columnsOrder = defaultColumnOrder }) => {
    const [allRows, setAllRows] = useState([]);
    const [rows, setRows] = useState([]);


    const prepareRows = (dataParam) => {
        let list = dataParam;
        if (!list.length) return [];
        list = list.map((row) => {
            const temp = { ...row };
            temp.autorizadoComponent = (
                <Checkbox
                    color={'primary'}
                    disabled={true}
                    checked={true}
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                />
            );
            temp.cnpj = helpers.formatarDocumento(temp.cnpj ? temp.cnpj : '');
            return temp;
        });
        return list;
    };

    const renderColumns = () => {
        const temp = [
            { id: 0, fieldName: 'cnpj', title: 'CNPJ', colOrder: columnsOrder.cnpj },
            { id: 1, fieldName: 'deRazaoSocial', title: 'Razão Social', colOrder: columnsOrder.deRazaoSocial },
            { id: 2, fieldName: 'cdEmpresa', title: 'Número de cadastro', colOrder: columnsOrder.cdEmpresa },
        ];
        if (isInternalForm && !disabled) {
            temp.push({ id: 3, fieldName: 'autorizadoComponent', title: '', colOrder: columnsOrder.autorizadoComponent });
        }
        temp.sort((a, b) => a.colOrder - b.colOrder);
        return temp;
    };

    useEffect(() => {
        (() => {
            setAllRows(data || []);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    useEffect(() => {
        (() => {

            setRows(prepareRows(allRows));
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [allRows]);

    return (
        <Grid item xs={12}>
            <h3 style={{ fontWeight: '500' }}>Concessionária</h3>
            <DefaultTable
                columns={renderColumns()}
                rows={rows}
                size={'small'}
                loading={loading}
                paginationProps={null}
            />
        </Grid>
    );
};

export default ConcessionariasTable;
